/**
 * LockPage - Lock responses confirmation
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';
import Header from '../components/shared/Header';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LockPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLock = async () => {
    setLoading(true);
    try {
      const relationshipId = sessionStorage.getItem('relationship_id');
      const userId = sessionStorage.getItem('user_id');

      const response = await axios.post(`${API}/responses/lock?user_id=${userId}`, {
        relationship_id: relationshipId
      });

      toast.success('Responses locked successfully!');
      
      // Check if both locked
      if (response.data.both_locked) {
        navigate('/reveal');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error locking responses:', error);
      toast.error('Failed to lock responses');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex items-center justify-center p-6" style={{minHeight: 'calc(100vh - 100px)'}}>
        <div className="max-w-lg w-full bg-white rounded-2xl border border-stone-100 shadow-sm p-12 text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Lock className="w-8 h-8 text-yellow-600" />
          </div>
          
          <h2 className="text-3xl font-bold text-stone-900 mb-4">Lock Your Responses</h2>
          
          <p className="text-stone-600 leading-relaxed mb-8">
            Once locked, your answers cannot be edited. They will remain private until your partner also locks their responses.
          </p>

          <div className="bg-stone-50 rounded-xl p-6 mb-8">
            <p className="text-sm text-stone-600">
              Your responses will be shared with your partner only after both of you have locked your answers.
            </p>
          </div>

          <button
            onClick={handleLock}
            disabled={loading}
            className="bg-mc-blue-deep text-white hover:bg-mc-blue-dark rounded-full px-8 py-4 text-lg font-medium transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 inline-flex items-center gap-2"
            data-testid="lock-responses"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Locking...
              </>
            ) : (
              <>
                Lock My Answers
                <Lock className="w-5 h-5" />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockPage;
